export const TAG_TYPES = {
  DIETARY: "Dietary",
  MEAL_TYPE: "MealType",
  UI: "UI",
  BEHAVIOR: "Behavior",
  ALLERGEN: "Allergen",
  SPICE: "SpiceLevel",
} as const;

export const TAG_CODES = {
  CUSTOMIZABLE: "CUSTOMIZABLE",
  REQUIRES_ADDON: "REQUIRES_ADDON",
  ADDON_ONLY: "ADDON_ONLY",
  /** Normal Menu Item that must never be offered as a standalone purchase. */
  NOT_SOLD_INDIVIDUALLY: "NOT_SOLD_INDIVIDUALLY",
  COMBO_ITEM: "COMBO_ITEM",
  BESTSELLER: "BESTSELLER",
  NEW: "NEW",
  TRENDING: "TRENDING",
  CHEF_SPECIAL: "CHEF_SPECIAL",
  RECOMMENDED: "RECOMMENDED",
  LIMITED_TIME: "LIMITED_TIME",
  VALUE_FOR_MONEY: "VALUE_FOR_MONEY",
  COMBO_DEAL: "COMBO_DEAL",
} as const;
